import React from 'react';

/**
 * 历史管理面板
 */
export default function HistoryPanel({
  historyTab,
  setHistoryTab,
  historyLoading,
  targetHistory,
  trackHistory,
  handleHistoryItemClick,
  canDeleteHistoryItem,
  handleDelete,
  handleToggleFinished
}) {
  return (
    <>
      <div style={{ marginBottom: 16 }}>
        <button
          onClick={() => setHistoryTab('target')}
          style={{
            marginRight: 10,
            padding: '6px 18px',
            background: historyTab === 'target' ? '#1976d2' : '#f5f5f5',
            color: historyTab === 'target' ? '#fff' : '#333',
            border: '1px solid #ddd',
            borderRadius: 4
          }}
        >
          目标历史
        </button>
        <button
          onClick={() => setHistoryTab('track')}
          style={{
            padding: '6px 18px',
            background: historyTab === 'track' ? '#1976d2' : '#f5f5f5',
            color: historyTab === 'track' ? '#fff' : '#333',
            border: '1px solid #ddd',
            borderRadius: 4
          }}
        >
          轨迹历史
        </button>
      </div>
      {historyLoading ? (
        <div>加载中...</div>
      ) : historyTab === 'target' ? (
        <div style={{ maxHeight: 500, overflowY: 'auto' }}>
          {targetHistory.length === 0 ? (
            <div style={{ color: '#888', padding: 12 }}>暂无历史记录</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f5f5f5', position: 'sticky', top: 0 }}>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>时间</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>有效至</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>消息</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>组</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>姓名</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>操作员</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>操作</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'center', whiteSpace: 'nowrap' }}>完结</th>
                </tr>
              </thead>
              <tbody>
                {targetHistory.map((item) => (
                  <tr key={item.id} style={{ borderBottom: '1px solid #eee', opacity: (item.status === '已完结' || (item.expires_at && new Date(item.expires_at).getTime() <= Date.now())) ? 0.65 : 1 }}>
                    <td
                      style={{
                        padding: '6px',
                        cursor: 'pointer',
                        color: '#1976d2',
                        textDecoration: 'underline',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => handleHistoryItemClick('target', item)}
                      title="点击飞行到该记录位置"
                    >
                      {new Date(item.created_at).toLocaleString()}
                    </td>
                    <td style={{ padding: '6px', whiteSpace: 'nowrap', color: item.expires_at && new Date(item.expires_at).getTime() <= Date.now() ? '#c62828' : undefined }}>
                      {item.expires_at ? new Date(item.expires_at).toLocaleString() : '—'}
                    </td>
                    <td style={{ padding: '6px', maxWidth: '140px', wordWrap: 'break-word' }}>{item.message || '无消息'}</td>
                    <td style={{ padding: '6px' }}>{item.group_name}</td>
                    <td style={{ padding: '6px' }}>{item.user_name}</td>
                    <td style={{ padding: '6px' }}>{item.operator_name || '系统管理员'}</td>
                    <td style={{ padding: '6px' }}>
                      {canDeleteHistoryItem(item) ? (
                        <button
                          onClick={() => handleDelete('target', item.id)}
                          style={{
                            padding: '4px 8px',
                            background: '#f44336',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 3,
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        >
                          删除
                        </button>
                      ) : (
                        <span style={{ color: '#999', fontSize: 12 }}>无权限</span>
                      )}
                    </td>
                    <td style={{ padding: '6px', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={item.status === '已完结'}
                        onChange={(e) => handleToggleFinished('target', item, e.target.checked)}
                        title={item.status === '已完结' ? '取消完结后会重新显示在指挥系统' : '完结后不再显示在指挥系统'}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      ) : (
        <div style={{ maxHeight: 500, overflowY: 'auto' }}>
          {trackHistory.length === 0 ? (
            <div style={{ color: '#888', padding: 12 }}>暂无历史记录</div>
          ) : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
              <thead>
                <tr style={{ background: '#f5f5f5', position: 'sticky', top: 0 }}>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>时间</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>消息</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>组</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>姓名</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>操作人员</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'left' }}>操作</th>
                  <th style={{ padding: '6px', border: '1px solid #ddd', textAlign: 'center', whiteSpace: 'nowrap' }}>完结</th>
                </tr>
              </thead>
              <tbody>
                {trackHistory.map((item) => (
                  <tr key={item.id} style={{ borderBottom: '1px solid #eee', opacity: item.status === '已完结' ? 0.65 : 1 }}>
                    <td
                      style={{
                        padding: '6px',
                        cursor: 'pointer',
                        color: '#1976d2',
                        textDecoration: 'underline',
                        whiteSpace: 'nowrap'
                      }}
                      onClick={() => handleHistoryItemClick('track', item)}
                      title="点击飞行到该记录位置"
                    >
                      {new Date(item.created_at).toLocaleString()}
                    </td>
                    <td style={{ padding: '6px', maxWidth: '140px', wordWrap: 'break-word' }}>{item.message || '无消息'}</td>
                    <td style={{ padding: '6px' }}>{item.group_name}</td>
                    <td style={{ padding: '6px' }}>{item.user_name}</td>
                    <td style={{ padding: '6px' }}>{item.operator_name || '系统管理员'}</td>
                    <td style={{ padding: '6px' }}>
                      {canDeleteHistoryItem(item) ? (
                        <button
                          onClick={() => handleDelete('track', item.id)}
                          style={{
                            padding: '4px 8px',
                            background: '#f44336',
                            color: '#fff',
                            border: 'none',
                            borderRadius: 3,
                            cursor: 'pointer',
                            fontSize: '12px'
                          }}
                        >
                          删除
                        </button>
                      ) : (
                        <span style={{ color: '#999', fontSize: 12 }}>无权限</span>
                      )}
                    </td>
                    <td style={{ padding: '6px', textAlign: 'center' }}>
                      <input
                        type="checkbox"
                        checked={item.status === '已完结'}
                        onChange={(e) => handleToggleFinished('track', item, e.target.checked)}
                        title={item.status === '已完结' ? '取消完结后会重新显示在指挥系统' : '完结后不再显示在指挥系统'}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </>
  );
}
